// 9fbef606107a605d69c0edbcd8029e5d
import internalEndpoints from '../../../common/internalEndpoints';
import { getDynamicLabelValues } from '../../../../../../utils/labels/labelUtilty';
/**
 * @function ctaRedirect  to get the route to CTA url based on activityModalAction
 * @param    {Object} activeActivity The activity details of waysToEarn
 * @returns  {Object} cta to and cta path for anchor
 */
const ctaRedirect = (activeActivity) => {
  switch (activeActivity.activityModalAction) {
    case 'rewardPlaceApp':
      return {
        to: getDynamicLabelValues('dynamic.account_d.lbl_appDownload_link'),
        path: getDynamicLabelValues('dynamic.account_d.lbl_appDownload_path'),
      };
    case 'userAboutYourselfSurvey':
      return {
        to: `${internalEndpoints.profilePage.link}&survey=true`,
        path: `${internalEndpoints.profilePage.path}/?survey=true`,
      };
    case 'userFavoriteStore':
      return {
        to: internalEndpoints.storeLocator.link,
        path: internalEndpoints.storeLocator.path,
      };
    case 'userMailing':
      return {
        to: internalEndpoints.mailingAddressPage.link,
        path: internalEndpoints.mailingAddressPage.path,
      };
    case 'myPreference':
      return {
        to: `${internalEndpoints.myPreferencesPage.link}&socialAccount=${activeActivity.activityModalSocialAccount}`,
        path: `${internalEndpoints.myPreferencesPage.path}/socialAccount=${activeActivity.activityModalSocialAccount}`,
      };
    case 'birthdaySavings':
      return {
        to: internalEndpoints.birthdaySavingsPage.link,
        path: internalEndpoints.birthdaySavingsPage.path,
      };
    case 'userBirthday':
      return {
        to: internalEndpoints.editProfileInformationPage.link,
        path: internalEndpoints.editProfileInformationPage.path,
      };
    case 'orders':
      return { to: internalEndpoints.myOrderPage.link, path: internalEndpoints.myOrderPage.path };
    default:
      return { to: internalEndpoints.profilePage.link, path: internalEndpoints.profilePage.path };
  }
};

export default ctaRedirect;
